export default "__VITE_ASSET__DB8FgbOl__"